import { useCallback, useContext } from 'react';

import chartContext from './chartContext';
import { ChartTypes, TradePair, TvWidgetType } from './chartTypes';

const useChartState = (): ChartTypes => {
    const context = useContext(chartContext);

    if (!Object.keys(context).length) {
        throw new Error('ChartContext must be used within its provider');
    }

    const { dispatch } = context;

    const setSelectedTradePair = useCallback(
        (pool: TradePair) => dispatch({ type: 'SET_SELECTED_TRADE_PAIR', payload: pool }),
        [dispatch]
    );

    const setTvWidget = useCallback(
        (widget: TvWidgetType) =>
            dispatch({
                type: 'SET_TV_WIDGET',
                payload: widget,
            }),
        [dispatch]
    );

    const setIsChartReady = useCallback(
        (isReady: boolean) =>
            dispatch({
                type: 'SET_IS_CHART_READY',
                payload: isReady,
            }),
        [dispatch]
    );

    const toggleAdvancedMode = useCallback(
        () =>
            dispatch({
                type: 'TOGGLE_ADVANCED_MODE',
            }),
        [dispatch]
    );

    const toggleFavouriteMarket = useCallback(
        (name: string) =>
            dispatch({
                type: 'TOGGLE_FAVOURITE_MARKET',
                payload: name,
            }),
        [dispatch]
    );

    return {
        ...context,
        setSelectedTradePair,
        setTvWidget,
        setIsChartReady,
        toggleAdvancedMode,
        toggleFavouriteMarket,
    };
};

export default useChartState;
